import { Link } from "react-router-dom";
import { HERO_IMG } from "../constants/states";
import { Logo, LogoMark } from "./Logo";

export function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="relative hidden md:block grain border-r-2 border-[#FF4D00]">
        <img src={HERO_IMG} alt="Angler on the beach at golden hour" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute bottom-10 left-10 right-10 font-display text-5xl uppercase leading-none">
          <LogoMark size={72} className="mb-6 shadow-[6px_6px_0_0_#F4F4F5]" />
          Know your<br /><span className="text-[#FF4D00]">catch.</span>
        </div>
      </div>
      <div className="flex flex-col px-5 py-8 sm:px-10">
        <Link to="/" className="self-start" data-testid="auth-logo-link"><Logo size={34} /></Link>
        <div className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-10 rise">
          <h1 className="font-display text-4xl sm:text-5xl uppercase leading-none">{title}</h1>
          {subtitle && <p className="mt-3 text-sm text-zinc-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function FormError({ msg, testId = "form-error" }) {
  if (!msg) return null;
  return <div data-testid={testId} className="border-2 border-[#EF4444] bg-[#EF4444]/10 text-[#fca5a5] text-sm px-3 py-2">{msg}</div>;
}
